import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: '',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: 'f8bd5a25-d469-40c9-8908-af208cb09035',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '436203ad-45f5-4330-840c-c39d8cecb15a',
      type: 'NineSlicePlane',
      name: 'SPProgressBar',
      nameSpace: '',
      className: '',
      x: 100,
      y: 60,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 200,
      height: 35,
      leftWidth: 16,
      topHeight: 8,
      rightWidth: 16,
      bottomHeight: 8,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_progress_bar_back',
      parent: 'f8bd5a25-d469-40c9-8908-af208cb09035',
      data: ''
    },
    {
      id: '371caf1e-048c-40ab-9b2b-03c1fe5de1c9',
      type: 'Container',
      name: 'SPTimer',
      nameSpace: '',
      className: '',
      x: 480,
      y: 78,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f8bd5a25-d469-40c9-8908-af208cb09035',
      data: ''
    },
    {
      id: 'c702dc04-1788-434c-9951-8b721f35bcf1',
      type: 'Sprite',
      name: 'SPActivatePremiumButton',
      nameSpace: '',
      className: '',
      x: 750,
      y: 80,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'btn_orange_long',
      parent: 'f8bd5a25-d469-40c9-8908-af208cb09035',
      data: ''
    },
    {
      id: 'f475286e-bb78-4391-bea6-737364a22955',
      type: 'Container',
      name: 'SPCompleteContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f8bd5a25-d469-40c9-8908-af208cb09035',
      data: ''
    },
    {
      id: '45d55420-2426-4105-a1e2-eb9cd5863b59',
      type: 'NineSlicePlane',
      name: 'SPProgressBarFill',
      nameSpace: '',
      className: '',
      x: 1,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 200,
      height: 35,
      leftWidth: 16,
      topHeight: 8,
      rightWidth: 16,
      bottomHeight: 8,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_progress_bar_green',
      parent: '436203ad-45f5-4330-840c-c39d8cecb15a',
      data: ''
    },
    {
      id: 'fc6b3bfa-09d9-41c7-bc34-3c3b23ab7999',
      type: 'NineSlicePlane',
      name: 'SPProgressBarFrontSprite',
      nameSpace: '',
      className: '',
      x: 1,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 200,
      height: 35,
      leftWidth: 16,
      topHeight: 8,
      rightWidth: 16,
      bottomHeight: 8,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_progress_bar_front',
      parent: '436203ad-45f5-4330-840c-c39d8cecb15a',
      data: ''
    },
    {
      id: '9b4c5b49-158f-4d98-a8b8-405cf14c954a',
      type: 'Text',
      name: 'SPProgressText',
      nameSpace: '',
      className: '',
      x: 100,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1/3',
      localize: false,
      maxWidth: 120,
      maxHeight: 40,
      maxFontSize: 25,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#1c6104',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '436203ad-45f5-4330-840c-c39d8cecb15a',
      data: ''
    },
    {
      id: '71c7bc7a-b169-45ab-8f21-f0786ec9280b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 200,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_icon_milestone',
      parent: '436203ad-45f5-4330-840c-c39d8cecb15a',
      data: ''
    },
    {
      id: 'bebda809-a39c-4466-957a-eb41be201966',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpoints_icon_title',
      parent: '436203ad-45f5-4330-840c-c39d8cecb15a',
      data: ''
    },
    {
      id: 'efb656bf-ce15-40b6-8a60-84d31fe357e1',
      type: 'NineSlicePlane',
      name: 'ProgressTooltip',
      nameSpace: '',
      className: '',
      x: 8,
      y: -107,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 200,
      height: 100,
      leftWidth: 30,
      topHeight: 0,
      rightWidth: 30,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_tooltip_bubble',
      parent: '436203ad-45f5-4330-840c-c39d8cecb15a',
      data: ''
    },
    {
      id: '9d17c84d-612c-4c36-bdc0-f437c74fb1b0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'offer_icon_timer',
      parent: '371caf1e-048c-40ab-9b2b-03c1fe5de1c9',
      data: ''
    },
    {
      id: '97bc2a2b-40ba-4f2a-8092-2f2a83a96e32',
      type: 'Text',
      name: 'timeText',
      nameSpace: '',
      className: '',
      x: 15,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '14 days',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: '#692012',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '371caf1e-048c-40ab-9b2b-03c1fe5de1c9',
      data: ''
    },
    {
      id: '784346e0-673a-4fd3-9a1b-344f0d7273b5',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassPremiumActivate',
      localize: true,
      maxWidth: 190,
      maxHeight: 35,
      maxFontSize: 20,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: '#9B2813',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 190,
        breakWords: false,
        lineHeight: 20,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'c702dc04-1788-434c-9951-8b721f35bcf1',
      data: ''
    },
    {
      id: '5823e68a-1afa-420a-a1d8-65fc2f97dbd7',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 71,
      y: 76,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassComplete',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 1,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#9B2813',
        stroke: '#9B2813',
        strokeThickness: 0,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 302,
        breakWords: false,
        lineHeight: 29,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f475286e-bb78-4391-bea6-737364a22955',
      data: ''
    },
    {
      id: '72d3e22c-a5bc-4634-a3ac-edd28730f100',
      type: 'Text',
      name: 'SPMilestoneText',
      nameSpace: '',
      className: '',
      x: 1,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3',
      localize: false,
      maxWidth: 120,
      maxHeight: 40,
      maxFontSize: 24,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8d3321',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '71c7bc7a-b169-45ab-8f21-f0786ec9280b',
      data: ''
    },
    {
      id: '724a0362-cc4c-4fe3-acbf-6076233c471a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 100,
      y: 72,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_tooltip_tail',
      parent: 'efb656bf-ce15-40b6-8a60-84d31fe357e1',
      data: ''
    },
    {
      id: 'c37607e9-735f-410f-bfff-01f09366599e',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 100,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassTooltipProgress',
      localize: true,
      maxWidth: 170,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8d3321',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 170,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.3,
        dropShadowBlur: 2,
        dropShadowColor: '#ffffff',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'efb656bf-ce15-40b6-8a60-84d31fe357e1',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class SeasonPassHeader {
  static raw = raw;
  root: PIXI.Container
  SPProgressBar: PIXI.NineSlicePlane
  SPProgressBarFill: PIXI.NineSlicePlane
  SPProgressBarFrontSprite: PIXI.NineSlicePlane
  SPProgressText: PIXI.Text
  SPMilestoneText: PIXI.Text
  ProgressTooltip: PIXI.NineSlicePlane
  SPTimer: PIXI.Container
  timeText: PIXI.Text
  SPActivatePremiumButton: PIXI.Sprite
  SPCompleteContainer: PIXI.Container

  constructor() {
    populate(this, raw);
  }
}
